import {Block} from '@travel-frontend/ui-components';
import {useEffect} from 'react';
import {Outlet} from 'react-router';

import {Wrapper} from '@/modules/common/components/Layout/components/Wrapper';
import {Footer} from '@/modules/common/components/Layout/Footer';
import {Header} from '@/modules/common/components/Layout/Header';

export const Layout: React.FunctionComponent = () => {
  useEffect(() => {
    document.getElementById('index-loader')?.remove();
  }, []);

  return (
    <Wrapper>
      <Header />
      <Block minWidth={0}>
        <Outlet />
      </Block>
      <Footer />
    </Wrapper>
  );
};
